function ShopifyCtrl(toaster, $stateParams, $state, ShopifyService, AppSettings, CommonService, $rootScope, UserService) {
    'ngInject';

    $rootScope.$on("UpdateShopifyInvoiceFromNotification", function(event, shopify_invoice) {
        vm.updateShopifyInvoiceFromNotification(shopify_invoice);
    });

    const vm = this;
    vm.shopifyForm = {};
    vm.shopifyfileForm = {};
    vm.shopify = [];
    vm.loading = false;
    vm.dataloading = false;
    vm.btndisabled = false;
    vm.responseReceived = false;
    vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
    vm.size = !$stateParams.size ? 50 : $stateParams.size;
    vm.shopifyForm.todate = !$stateParams.todate ? '' : $stateParams.todate;
    vm.shopifyForm.fromdate = !$stateParams.fromdate ? '' : $stateParams.fromdate;
    vm.invoiceId = !$stateParams.invoiceId ? '' : $stateParams.invoiceId;
    vm.sortByShopify = !$stateParams.sortBy ? '' : $stateParams.sortBy;
    vm.sortFlag = false;
    vm.regex = '^[-+]?[0-9]*\.?[0-9]+$';
    vm.dateRegex = AppSettings.dateRegex;
    vm.yearMonthRegex = AppSettings.yearMonthRegex;
    vm.isShopifyPendingJobs = false;
    vm.tryNowDate = '';

    vm.init = function () {
        vm.url = `/organizations/${$stateParams.orgId}/shopify_invoices.json?page=${vm.pageNumber}&size=${vm.size}&by_invoice_id=${vm.invoiceId}&by_from=${vm.shopifyForm.fromdate}&by_to=${vm.shopifyForm.todate}&sort=${vm.sortByShopify}`;
        vm.loading = true;
        vm.dataloading = true;
        if ($stateParams.orgId) {
            ShopifyService.getshopifyInvoices($stateParams.orgId, vm.url, vm.pageNumber, vm.size, function (response) {
                vm.loading = false;
                vm.dataloading = false;
                if (response.status == 200) {
                    vm.shopifyResponse = response.data;
                    vm.currentPage = !vm.shopifyResponse.pagination ? 1 : vm.shopifyResponse.pagination.current_page;
                    vm.totalPages = !vm.shopifyResponse.pagination ? 1 : vm.shopifyResponse.pagination.total_pages;
                    vm.shopifyInvoices = response.data.shopify_invoices;
                }
            })
            vm.shopifyPending();
        }
    };

    vm.shopifyPending = function() {
        UserService.showShopifyPendingJob($stateParams.orgId, function(response) {
            vm.isShopifyPendingJobs = response && response.data && response.data.count > 0;
        });
    };

    vm.updateShopifyInvoiceFromNotification = function(shopify_invoice) {
        if (Array.isArray(shopify_invoice)) {
            vm.init();
        }
    };


    vm.search = function(inId, fromdate, todate) {
        $state.go('user.organization.dashboard.shopify.invoice', { pageNumber: vm.pageNumber, size: vm.size, invoiceId: inId, fromdate: fromdate, todate: todate })
    };

    vm.sortFlag = function(param) {
        var currentSort = $stateParams.sortBy;
        if (currentSort && currentSort.includes(param)) {
            if (!currentSort.includes('-')) {
                return false;
            }
        }
        return true;
    };

    vm.sort = function(param) {
        var currentSort = $stateParams.sortBy;
        if (currentSort && currentSort.includes(param)) {
            if (!currentSort.includes('-')) {
                param = '-' + param;
            }
        }
        $state.go('user.organization.dashboard.shopify.invoice', { sortBy: param });
    };

    vm.viewDetail = function(invoiceId) {
        $state.go('user.organization.dashboard.shopify.detail', { orgId: $stateParams.orgId, invoiceid: invoiceId }, { inherit: false });
    };

    vm.getInvoiceTotal = function() {
        let total = 0;
        if (vm.mapping) {
            vm.mapping.api_v1_shopify_mapping_acs.forEach(function(d) {
                let amount = (vm.getUnitPrice(d.account_name) * 1)
                total = ('merchant_account_fees' == d.account_name) ? (total - amount) : (total + amount)
            });
            return total;
        }
    }

    vm.getInvoice = function() {
        if ($stateParams.invoiceid) {
            ShopifyService.getInvoice($stateParams.orgId, $stateParams.invoiceid, function(response) {
                vm.invoice = response.data;
                vm.mapping = response.data.mapping;
            });
        } else {
            $state.go('user.organization.dashboard.shopify.invoice', { inherit: false });
        }
    }

    vm.getUnitPrice = function(accountName) {
        switch (accountName) {
            case 'shopify_sales':
                return vm.invoice.sales;
                break;
            case 'shipping_income':
                return vm.invoice.shipping;
                break;
            case 'sales_tax_liability':
                return vm.invoice.taxes;
                break;
            case 'merchant_account_fees':
                return vm.invoice.merchant_fees;
                break;
            case 'refund_after_sales':
                return vm.invoice.refunds;
                break;
            default:
                return '';
        }
    }
    vm.isNegativeDisplay = function(accountName, which) {
        if (accountName == 'merchant_account_fees' || accountName == 'refund_after_sales') {
            return which ? '(' : ')';
        } else {
            return '';
        }

    }

    vm.paginate = function(param) {
        vm.url = vm.shopifyResponse.links[param];
        if (vm.url) {
            var arr = vm.url.split('?');
            vm.pageNumber = CommonService.getParameterByName('page', vm.url);
            vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
            $state.go('user.organization.dashboard.shopify.invoice', { pageNumber: vm.pageNumber, size: vm.size });
        }
    };

    vm.rowChange = function(param, pageSize) {
        vm.url = vm.shopifyResponse.links[param];
        var arr = vm.url.split('?');
        vm.pageNumber = 1;
        vm.size = pageSize;
        vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
        $state.go('user.organization.dashboard.shopify.invoice', { pageNumber: vm.pageNumber, size: vm.size })
    };

    vm.onPikadaySelect = function(pikaday) {
        vm.shopifyfileForm.date = pikaday.toString('YYYY-MM-DD');
    };

    vm.onPikadayOpen = function(pikaday) {
        vm.shopifyfileForm.date.setMaxDate(new Date());
    }

    vm.onPickadayTo = function(pikaday) {
        vm.shopifyForm.todate = pikaday.toString();
        vm.fromDatePicker.setMaxDate(new Date(vm.shopifyForm.todate));
    };

    vm.onPickadayFrom = function(pikaday) {
        vm.shopifyForm.fromdate = pikaday.toString();
        vm.toDatePicker.setMinDate(new Date(vm.shopifyForm.fromdate));
    };

    vm.saveFile = function(shopifyForm) {
        vm.loading = true;
        vm.btndisabled = true;
        vm.responseReceived = false;
        ShopifyService.reportExists($stateParams.orgId, vm.shopifyfileForm.date, function(resp) {
            if (resp.data && !resp.data.errors) {
                // if (resp.data.status == 'success'){
                //   swal({
                //     title: "Are you sure?",
                //     text: "The invoice of Shopify payout report for this month is already created.",
                //     icon: "warning",
                //     dangerMode: true,
                //   })
                //     .then(willDelete => {
                //     if (willDelete) {
                //       vm.loading = false;
                //       vm.btndisabled = false;
                //       vm.responseReceived = true;
                //       // vm.uploadShopifyFile(shopifyForm);
                //     } else {
                //       vm.loading = false;
                //       vm.btndisabled = false;
                //       vm.responseReceived = true;
                // }
                // });
                // } else {
                vm.uploadShopifyFile(shopifyForm);
                // }
            } else {
                vm.loading = false;
                vm.btndisabled = false;
                vm.responseReceived = true;
                toaster.pop('error', CommonService.throwError(resp));
            }
        });

        vm.uploadShopifyFile = function(shopifyForm) {
            ShopifyService.saveFile(vm.shopifyfileForm, $stateParams.orgId, function(response) {
                vm.loading = false;
                vm.btndisabled = false;
                vm.responseReceived = true;
                vm.shopifyfileForm = {};
                shopifyForm.$setPristine();
                shopifyForm.$setUntouched();
                if (response.status >= 200 & response.status < 300) {
                    toaster.pop('info', 'File uploaded successfully');
                } else {
                    toaster.pop('error', CommonService.throwError(response));
                }
            });
        };
    };

    vm.onTryNowDateSelect = function (pikaday) {
        vm.tryNowDate = pikaday.toString('YYYY-MM-DD');
    };

    vm.tryNow = function () {
        vm.tryLoading = true;
        ShopifyService.tryNow($stateParams.orgId, vm.tryNowDate, function (response) {
            vm.tryLoading = false;
            if (response.status >= 200 && response.status < 300) {
                toaster.pop('info', response.data.data);
            } else {
                toaster.pop('error', CommonService.throwError(response));
            }
        });
    };

    vm.onPikadayOpenTryNow = function(pikaday) {
        pikaday.setMaxDate(new Date());
    };
}

export default {
    name: 'ShopifyCtrl',
    fn: ShopifyCtrl
}